exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width { width: 100%;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/modify-card/update-title/update-title.component.css
// module id = ../../../../../src/app/hq/cards/modify-card/update-title/update-title.component.css
// module chunks = main